import { IconName } from '@optimus-web/icons';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ExpandableListItemProps } from '@optimus-web/core';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

type Props = Partial<ExpandableListItemProps> & {
    value: string;
};
export const EnterprisePoliciesMenu = (props: Props) => (
    <SidebarExpandableListItem
        leftIcon={<SidebarFontIcon value={IconName.GatewayPayments} />}
        primaryText={lt('MultiPropertyPoliciesMenuLabel')}
        {...props}
    >
        {createListItemWithLink({
            textKey: TextKey.MultiPropertyCancellationMenuLabel,
            path: 'EnterprisePolicies/CancellationPolicies/Index',
            iconName: IconName.GatewayPayments,
            tooltip: null,
            isMainItem: true,
        })}
        {createListItemWithLink({
            textKey: TextKey.MultiPropertyPaymentMenuLabel,
            iconName: IconName.GatewayPayments,
            path: 'EnterprisePolicies/PaymentPolicies/Index',
            tooltip: null,
            isMainItem: true,
        })}
    </SidebarExpandableListItem>
);
